/**
 * open_external_links.js
 * Automatically adds target="_blank" and rel="noopener" to all links
 * that point to an external domain (not the current store's domain).
 */

document.addEventListener('DOMContentLoaded', function() {
    // Get the current store's hostname (e.g., 'your-store.myshopify.com' or 'yourdomain.com')
    const storeHostname = window.location.hostname;

    // Select all anchor links on the page
    const allLinks = document.querySelectorAll('a');

    allLinks.forEach(link => {
        // 1. Check if the link has an href and the href starts with http/https
        if (link.href && link.protocol.startsWith('http')) {
            
            // 2. Create a temporary URL object to easily access the hostname of the link
            let linkUrl;
            try {
                linkUrl = new URL(link.href);
            } catch (e) {
                // Skip invalid or malformed URLs
                return;
            }

            // 3. Compare the link's hostname against the store's hostname
            if (linkUrl.hostname !== storeHostname) {
                // This is an external link, so add the attributes
                link.setAttribute('target', '_blank');
                
                // rel="noopener" is a security best practice for all target="_blank" links
                link.setAttribute('rel', 'noopener');
                
                // Optional console log to confirm which links are being modified
                // console.log('External link modified:', link.href);
            }
        }
    });
});